var map = {
	"./sdg_icon_1.png": 506,
	"./sdg_icon_10.png": 507,
	"./sdg_icon_11.png": 508,
	"./sdg_icon_12.png": 509,
	"./sdg_icon_13.png": 510,
	"./sdg_icon_14.png": 511,
	"./sdg_icon_15.png": 512,
	"./sdg_icon_16.png": 513,
	"./sdg_icon_17.png": 514,
	"./sdg_icon_2.png": 515,
	"./sdg_icon_3.png": 516,
	"./sdg_icon_4.png": 517,
	"./sdg_icon_5.png": 518,
	"./sdg_icon_6.png": 519,
	"./sdg_icon_7.png": 520,
	"./sdg_icon_8.png": 521,
	"./sdg_icon_9.png": 522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 305;